export default __webpack_public_path__ + "static/15aa-d6610f4b56105fb97294eb060085867d.png";